import React from "react";
import { Link } from "react-router-dom";

// Material UI Icons
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import PersonIcon from '@mui/icons-material/Person';
import StraightenIcon from '@mui/icons-material/Straighten';
import GroupsIcon from '@mui/icons-material/Groups';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FlagIcon from '@mui/icons-material/Flag';

// Components
import YachtImageSlider from './YachtImageSlider';

function YachtCard({ yacht }) {
    // Yat tipini sayıdan metne çeviren fonksiyon
    const getYachtTypeText = (typeNumber) => {
        const types = {
            1: "Motor Yacht",
            2: "Sailing Yacht",
            3: "Catamaran",
            4: "Luxury Yacht",
            5: "Super Yacht",
        };
        return types[typeNumber] || "Bilinmiyor";
    };

    return (
        <div
            className="bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 overflow-hidden hover:shadow-lg hover:shadow-blue-500/10 transition-all duration-300 transform hover:-translate-y-1"
        >
            {/* Resim Slider */}
            <div className="relative aspect-[16/9]">
                <YachtImageSlider 
                    images={yacht.yachtImages || yacht.fotoLinks} 
                    yachtName={yacht.name}
                />
            </div>

            {/* Yat Bilgileri */}
            <div className="p-6">
                <h3 className="text-xl font-semibold text-white mb-2">
                    {yacht.name}
                </h3>
                
                <div className="space-y-2 text-white/60 mb-4">
                    <p className="flex items-center gap-2">
                        <DirectionsBoatIcon fontSize="small" />
                        {getYachtTypeText(yacht.type)}
                    </p>
                    <p className="flex items-center gap-2">
                        <PersonIcon fontSize="small" />
                        {yacht.captain}
                    </p>
                    <p className="flex items-center gap-2">
                        <StraightenIcon fontSize="small" />
                        {yacht.length}m
                    </p>
                    <p className="flex items-center gap-2">
                        <GroupsIcon fontSize="small" />
                        {yacht.capacity} misafir
                    </p>
                    <p className="flex items-center gap-2">
                        <CalendarTodayIcon fontSize="small" />
                        {yacht.year}
                    </p>
                    <p className="flex items-center gap-2">
                        <FlagIcon fontSize="small" />
                        {yacht.flag}
                    </p>
                </div>

                {/* Fiyat */}
                <div className="mb-4">
                    <p className="text-green-400 font-semibold text-lg">
                        {new Intl.NumberFormat('tr-TR', {
                            style: 'currency',
                            currency: ['TRY', 'USD', 'EUR', 'GBP'].includes(yacht.currency) ? yacht.currency : 'EUR'
                        }).format(yacht.price)}
                    </p>
                </div>

                {/* Detay Butonu */}
                <Link
                    to={`/yachts/${yacht.id}`}
                    className="block w-full text-center py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300"
                >
                    Detayları Gör
                </Link>
            </div>
        </div>
    );
}

export default YachtCard;
